import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useDepartments = () => {
  const { tenantId } = useAuth();

  return useQuery({
    queryKey: ['departments', tenantId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('departamentos')
        .select('id, nome, sigla')
        .eq('tenant_id', tenantId)
        .order('nome', { ascending: true });

      if (error) throw error;
      return data || [];
    },
    enabled: !!tenantId,
  });
};
